module.exports = __webpack_public_path__ + "img/workday.f9f876ab.svg";